import { appState } from '../store/appState.js';

// Hàm lấy tỉ giá (Đã sửa lỗi để lấy đủ 160+ quốc gia)
export async function fetchExchangeRates() {
    try {
        console.log('[API] Đang tải cập nhật Tỉ giá Ngoại tệ...');
        const res = await fetch('https://open.er-api.com/v6/latest/USD');
        const data = await res.json();

        if (data && data.rates && data.rates.VND) {
            const vndRate = data.rates.VND; // Tỉ giá USD/VND gốc

            // Xóa trắng bộ đệm cũ, đảm bảo VND luôn ở đầu
            appState.exchangeRatesCache = { 'VND': 1 };

            // Lặp qua toàn bộ danh sách 160+ nước do API trả về
            for (const [currencyCode, rateVsUSD] of Object.entries(data.rates)) {
                if (currencyCode !== 'VND') {
                    // Công thức tính tỉ giá chéo: Giá VND của 1 đồng ngoại tệ
                    appState.exchangeRatesCache[currencyCode] = vndRate / rateVsUSD;
                }
            }

            console.log(`[API] Đã tải thành công tỉ giá của ${Object.keys(appState.exchangeRatesCache).length} loại tiền tệ.`);
        }
    } catch (error) {
        console.error('[API] Lỗi tải tỉ giá (Sẽ dùng list mặc định):', error);
    }
}
